import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import api, { API, getToken } from "@/lib/api";

export default function Chat({ appointmentId, user }) {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const ws = useRef(null);
  const logRef = useRef(null);

  const scrollDown = () => setTimeout(() => { if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight; }, 50);

  useEffect(() => {
    let active = true;
    api.get(`/appointments/${appointmentId}/messages`).then(r => {
      if (active) { setMessages(r.data.messages || []); scrollDown(); }
    });
    const tok = getToken();
    const wsUrl = API.replace(/^http/, "ws") + `/ws/chat/${appointmentId}` + (tok ? `?token=${encodeURIComponent(tok)}` : "");
    const socket = new WebSocket(wsUrl);
    ws.current = socket;
    socket.onmessage = (e) => {
      const msg = JSON.parse(e.data);
      setMessages(prev => [...prev, msg]);
      scrollDown();
    };
    return () => { active = false; socket.close(); };
  }, [appointmentId]);

  const send = () => {
    const t = text.trim();
    if (!t || !ws.current || ws.current.readyState !== 1) return;
    ws.current.send(JSON.stringify({ text: t }));
    setText("");
  };

  return (
    <div className="chat" data-testid="chat-panel">
      <div className="chat-log" ref={logRef}>
        {messages.length === 0 && <p style={{ color: "var(--slate)", fontSize: 13, textAlign: "center", margin: "auto" }}>No messages yet. Say hello 👋</p>}
        {messages.map((m, i) => {
          const me = m.sender_id === user.id;
          return (
            <div className={`bubble ${me ? "me" : "them"}`} key={i}>
              {!me && <span className="who">{m.sender_name}</span>}
              {m.text}
            </div>
          );
        })}
      </div>
      <div className="chat-in">
        <input
          value={text}
          onChange={e => setText(e.target.value)}
          onKeyDown={e => e.key === "Enter" && send()}
          placeholder="Type a message…"
          data-testid="chat-input"
        />
        <button className="btn btn-ink btn-sm" onClick={send} data-testid="chat-send"><Send size={15} /></button>
      </div>
    </div>
  );
}
